import { Text, TextProps } from "@mantine/core"

interface ValidationTextProps extends Omit<TextProps, "c"> {
  isValid: boolean
  children: React.ReactNode
}

export const ValidationText = ({
  isValid,
  children,
  ...props
}: ValidationTextProps) => {
  return (
    <Text c={isValid ? "green" : "red"} {...props}>
      {children}
    </Text>
  )
}
